'use client';

import { useLocale } from '@/hooks/useLocale';
import { cn } from '@/lib/utils';
import { useEffect, useRef, useSyncExternalStore } from 'react';

const subscribeNever = () => () => {};

export default function TrustBox() {
  const ref = useRef<HTMLDivElement | null>(null);
  const lang = useLocale();
  // The Trustpilot bootstrap fills every .trustpilot-widget it finds. Inside a streamed Suspense
  // boundary it can run before React hydrates the widget, and the injected iframe breaks
  // hydration (#418). The class is added only after hydration, so the script never sees it first.
  const hydrated = useSyncExternalStore(
    subscribeNever,
    () => true,
    () => false,
  );

  const localeMap: Record<string, string> = {
    en: 'en-GB',
    it: 'it-IT',
    de: 'de-DE',
    fr: 'fr-FR',
  };

  useEffect(() => {
    const trustpilot = (window as any).Trustpilot;

    if (hydrated && trustpilot) {
      trustpilot.loadFromElement(ref.current, true);
    }
  }, [hydrated]);

  return (
    <div
      ref={ref}
      className={cn(
        'pt-4 pb-8 desktop:py-0 font-medium desktop:max-w-[230px]',
        {
          'trustpilot-widget': hydrated,
          'desktop:max-w-[235px]': lang === 'de',
        },
      )}
      data-locale={localeMap[lang]}
      data-template-id="5419b637fa0340045cd0c936"
      data-businessunit-id="60f03f2970d674000116f325"
      data-style-height="20px"
      data-style-width="100%">
      <a
        href={`https://${lang === 'en' ? 'uk' : lang}.trustpilot.com/review/www.villatravellers.com`}
        target="_blank"
        rel="noopener"></a>
    </div>
  );
}
